import React from 'react'

import { ZariContext } from '_zari/context'

import { Alert, Portlet, Col, Row, Button } from '_zari/core'

import { PeriodoContext } from 'contexts/PeriodoContext'

import { DownloadAxiosFile } from 'utils'

import * as AsientoContableService from 'services/asientosContables.service'

const portletBreadcrumbs = [{ name: 'Pase Inventarios' }]

const MainForm = () => {
  const __zariContext = React.useContext(ZariContext)
  const __periodoContext = React.useContext(PeriodoContext)

  const [existeAsientos, setExisteAsientos] = React.useState(false)

  React.useEffect(() => {
    AsientoContableService.verificarAsientosKardex()
      .then(({ data }) => {
        if (data) {
          setExisteAsientos(data)
        } else {
          setExisteAsientos(false)
        }
      })
      .catch(() => {
        setExisteAsientos(false)
      })
  }, [])

  const clickGenerarDeInventarios = flagReporte => {
    __zariContext.loader.open('Generando asientos de inventarios ...')

    AsientoContableService.generarDeInventarios(flagReporte)
      .then(({ data, headers }) => {
        DownloadAxiosFile.downloadAsBlob(data, headers)
        __zariContext.snack('success', 'Migrado correctamente.')
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
      .finally(() => {
        __zariContext.loader.close()
        if (!flagReporte) {
          __periodoContext.actualizarEstados()
        }
      })
  }

  return (
    <>
      <Portlet>
        <Portlet.Header title='Pase Inventarios' breadcrumbs={portletBreadcrumbs} />
        <Portlet.Body>
          {existeAsientos ? (
            <Alert color='success'>Se han encontrado asientos de pase de inventarios.</Alert>
          ) : (
            <Alert color='warning'>No se han encontrado asientos de pase de inventarios.</Alert>
          )}
          <Row>
            <Col md={12} className={existeAsientos ? 'text-right' : ''}>
              <Button onClick={() => clickGenerarDeInventarios(false)}>Generar de Inventarios</Button>
              {existeAsientos && <Button onClick={() => clickGenerarDeInventarios(true)}>Descargar reporte</Button>}
            </Col>
          </Row>
        </Portlet.Body>
      </Portlet>
    </>
  )
}

export default React.memo(MainForm)
